export default (httpClient) => ({
  
  // PONTUAÇÃO DO DIA
  getAllDia: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pontuacao-do-dia-admin", { headers });
    return { data: response.data };
  },

  // PONTUAÇÃO MENSAL
  getAllMensal: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pontuacao-mensal-admin", { headers });
    return { data: response.data };
  },
});
